import { Text, Illustration, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

interface DownloadProps {}

export const Download: React.FC<DownloadProps> = () => {
  return (
    <VStack
      space={Spacing['inline.xxxs']}
      alignItems="center"
      justifyContent="center"
      bg={{
        base: 'tranparent',
        sm: 'neutral.white',
      }}
      borderRadius={BoxRadius.sm}
      h={{ base: 'full', lg: '566px' }}>
      <Illustration name="DownloadIllustration" />
      <VStack space={Spacing['inline.nano']} mx={Spacing['inline.md']}>
        <Text variant="bold" fontSize={Typography['fontsize.md']} textAlign="center">
          Faça o download dos títulos do cliente.
        </Text>
        <Text fontSize={Typography['fontsize.md']} textAlign="center">
          Para realizar o download selecione período em seguida selecione o titulo e clique em
          download.
        </Text>
      </VStack>
    </VStack>
  );
};
